import { createResource, useResource } from '@atlassian/react-resource-router';
import { getAssetsReportingConfig, type AssetsReportingConfig } from './services/index.tsx';

export const RESOURCE_ASSETS_REPORTING_CONFIG = 'assets-reporting-config';
export const RESOURCE_ASSETS_REPORTING_CONFIG_KEY = 'assets.reporting.config';

export const assetsReportingConfigResource = createResource<AssetsReportingConfig>({
	type: RESOURCE_ASSETS_REPORTING_CONFIG,
	getKey: () => RESOURCE_ASSETS_REPORTING_CONFIG_KEY,
	getData: async () => getAssetsReportingConfig(),
});

export const useAssetsReportingConfigResource = () =>
	useResource<AssetsReportingConfig>(assetsReportingConfigResource);
